<template>
    <v-row align="center" class="mt-8">
        <v-col cols="auto" class="px-0 align-self-start">
            <v-icon
                    size="75"
                    :color="icone_decisao.color || ''"
                    v-bind:class="icone_decisao.class || {}">
                {{ icone_decisao.icon || '' }}
            </v-icon>
        </v-col>
        <v-col class="align-self-start mt-2 overflow-y-visible">
            <h3 class="mb-0 text-start text-h6 color-primary">{{ label_decisao }}</h3>
            <v-skeleton-loader class="mt-0 mb-0" v-if="buscandoMotivoDecisaoCredito" type="text,text"></v-skeleton-loader>
            <p v-else class="mt-0 mb-0 text-start text--advice_friendly" style="font-size:1rem; font-weight: bold; white-space: pre-wrap;">{{ motivoLocal }}</p>
        </v-col>
    </v-row>
</template>

<script>
  import { SituationAnalysisCredit } from '../../plugins/constants'
  export default {
    name: 'IndicadorDecisaoCredito',
    props: {
      isReprovada: Boolean,
      isAprovada: Boolean,
      isPendente: { type: Boolean, default: false },
      isPendenciaCadastral: { type: Boolean, default: false },
      motivo: String,
      idPedido: {
        type: [String, Number],
        required: false
      }
    },
    data () {
      return {
        mapeamentoIconeCredito: {
          [SituationAnalysisCredit.APROVADO]: { icon: 'mdi-emoticon-happy-outline', color: 'success', class: {} },
          [SituationAnalysisCredit.REPROVADO]: { icon: 'mdi-emoticon-cry-outline', color: 'dark', class: {} },
          [SituationAnalysisCredit.PENDENTE]: { icon: 'mdi-', color: 'neutral', class: { 'mt-2': true } },
          [SituationAnalysisCredit.PENDENCIA_CADASTRAL]: { icon: 'mdi-account-plus', color: 'info', class: { } }
        },
        mapeamentoLabelDecisao: {
          [SituationAnalysisCredit.APROVADO]: 'Motivo da Aprovação de Crédito:',
          [SituationAnalysisCredit.REPROVADO]: 'Motivo da Recusa de crédito:',
          [SituationAnalysisCredit.PENDENTE]: 'Motivo da avaliação de crédito:',
          [SituationAnalysisCredit.PENDENCIA_CADASTRAL]: 'Motivo da Pendência de Crédito:'
        },
        buscandoMotivoDecisaoCredito: false,
        motivoLocal: this.motivo
      }
    },
    computed: {
      decisao_credito () {
        if (this.isAprovada) {
          return SituationAnalysisCredit.APROVADO
        }
        if (this.isReprovada) {
          return SituationAnalysisCredit.REPROVADO
        }
        if (this.isPendente) {
          return SituationAnalysisCredit.PENDENTE
        }
        if (this.isPendenciaCadastral) {
          return SituationAnalysisCredit.PENDENCIA_CADASTRAL
        }
        return ''
      },
      icone_decisao () {
        return this.mapeamentoIconeCredito[this.decisao_credito] ?? {}
      },
      label_decisao () {
        return this.mapeamentoLabelDecisao[this.decisao_credito] ?? ''
      }
    },
    watch: {
      motivo: {
        immediate: true,
        handler (novoValor) {
          this.motivoLocal = novoValor
        }
      },
      isReprovada (novaOpcao) {
        if (novaOpcao) {
          this.isAprovada = false
          this.isPendente = false
          this.isPendenciaCadastral = false
          this.buscarMotivo()
        }
      },
      isPendente (novaOpcao) {
        if (novaOpcao) {
          this.isAprovada = false
          this.isReprovada = false
          this.isPendenciaCadastral = false
          this.buscarMotivo()
        }
      },
      isPendenciaCadastral (novaOpcao) {
        if (novaOpcao) {
          this.isAprovada = false
          this.isReprovada = false
          this.isPendente = false
          this.buscarMotivo()
        }
      },
      isAprovada (novaOpcao) {
        if (novaOpcao) {
          this.isReprovada = false
          this.isPendente = false
          this.isPendenciaCadastral = false
          this.buscarMotivo()
        }
      }
    },
    methods: {
      async buscarMotivo () {
        if (this.idPedido) {
          this.buscandoMotivoDecisaoCredito = true
          this.motivoLocal = await this.getMotivoDecisaoCreditoOnline(this.idPedido)
          this.buscandoMotivoDecisaoCredito = false
        }
      },
      async getMotivoDecisaoCreditoOnline (id_pedido) {
        const motivo = await this.$http.get(`/pedido/motivo_decisao_credito/${id_pedido}`, { options: { silent: true } })
          .then(response => response.data.motivo_decisao_credito)
          .catch(() => '')
        return motivo
      }
    }
  }
</script>
